export const YATTA_SUPPORT_PHONE_NUMBER = '+49 69 2475666-0';
export const YATTA_SUPPORT_EMAIL_ADDRESS = 'support@yatta.de';
export const YATTA_VENDOR_SUPPORT_EMAIL_ADDRESS = 'checkout@yatta.de';
export const YATTA_UNSUBSCRIBE_EMAIL_ADDRESS = 'unsubscribe@yatta.de';
export const YATTA_ACADEMIC_SUPPORT_EMAIL_ADDRESS = 'academic@yatta.de';
